/**
 * Jeff's exact string (2026-09-03, reaffirmed 09-07): one label, not a label
 * plus a note. The ONE literal in the bundle — the SKU page and the Products
 * list both import it from here, and the dist grep looks for it.
 *
 * Split on the em dash so the qualifier can carry the warning treatment
 * (weight, border, neutral ink) instead of reading as plain label text. If
 * that split ever fails to land on exactly two parts — someone edits the
 * string without preserving ' — ' — the whole string is used as the
 * qualifier rather than silently rendering an empty one.
 */
export const SKU_LIST_PRICE_LABEL = "ESL list price — not your customer's price"

const PARTS = SKU_LIST_PRICE_LABEL.split(' — ')

/** "ESL list price", or null when the literal no longer splits in two. */
export const SKU_LIST_PRICE_LEAD: string | null = PARTS.length === 2 ? (PARTS[0] ?? null) : null

// Sentence-cased for display: stacked into its own element, the lowercase
// mid-sentence fragment reads as truncated rather than as a continuation of
// the line above it. Derived, never hand-authored.
const QUALIFIER_FRAGMENT = PARTS.length === 2 ? (PARTS[1] ?? SKU_LIST_PRICE_LABEL) : SKU_LIST_PRICE_LABEL

/** "Not your customer's price." */
export const SKU_LIST_PRICE_QUALIFIER = `${QUALIFIER_FRAGMENT.charAt(0).toUpperCase()}${QUALIFIER_FRAGMENT.slice(1)}.`

/** price1 null or 0 (task decision 2026-11-02). Never $0.00. */
export const PRICE_MISSING = 'Contact ESL for pricing'

/** available NULL: no allowlisted row, a NULL quantity, or a negative or
 *  fractional sum — the BC writer's "unknown". Never 0. */
export const STOCK_UNKNOWN = 'Stock unknown'

/** An item with no row at all in rep_stock_price (not a PIMBERLY item). */
export const NOT_A_CATALOG_ITEM = 'Not a stocked catalog item. Contact ESL for availability.'
